/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { FormInput, FormGroup, FormFeedback } from 'shards-react';
import { Box, Button } from '@material-ui/core';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import './style.css';

export default function AutoComplete(prop) {
  const { t, i18n } = useTranslation();
  let {
    label,
    data = [],
    inputHasErrors,
    placeholder,
    defaultValue = [],
    valueObject,
    titleObject,
    groupByObject,
    updateValueObject,
    updateTitleObject,
    addFunction,
    disabled,
    ready,
  } = prop;

  if (!ready && updateValueObject) return <></>;

  if (!defaultValue && updateValueObject) return <></>;

  const makeDataReadable = (data, type = 'data') => {
    if (!data) return [];
    if (type === 'data') {
      const filterData = data.filter((res) => {
        for (const i in defaultValue) {
          if (defaultValue[i] === res[valueObject]) return false;
        }
        return true;
      });
      return filterData.map((res) => {
        return { value: res[valueObject], title: res[titleObject], parent: groupByObject ? res[groupByObject] : null };
      });
    } else {
      if (Array.isArray(data)) {
        return data.map((res) => {
          return {
            value: res[updateValueObject],
            title: res[updateTitleObject],
          };
        });
      } else {
        return {
          value: data[updateValueObject],
          title: data[updateTitleObject],
        };
      }
    }
  };

  const onClickAdd = () => {
    Swal.fire({
      title: t('swal.create_new'),
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: t('swal.confim'),
      cancelButtonText: t('swal.cancel'),
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        addFunction(name);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  return (
    <div>
      {label && <label className="capitalize-first-letter">{label}</label>}
      <FormGroup>
        <Autocomplete
          {...prop}
          groupBy={groupByObject ? (option) => option.parent : null}
          limitTags={disabled ? 100 : 2}
          size="small"
          id="multiple-limit-tags"
          options={makeDataReadable(data, 'data')}
          getOptionLabel={(option) => option.title}
          defaultValue={makeDataReadable(defaultValue, 'defaultValue')}
          renderInput={(params) => (
            <div style={{ position: 'relative' }}>
              {addFunction ? <AddIcon className="auto-complete-add-icon" onClick={onClickAdd} /> : ''}
              <TextField
                {...params}
                variant="outlined"
                label=""
                placeholder={disabled ? '' : placeholder}
                error={inputHasErrors}
              />
            </div>
          )}
          closeIcon={<CloseIcon className={addFunction ? 'auto-complete-close-icon make-space' : 'auto-complete-close-icon'} />}
          noOptionsText={
            addFunction ? (
              <Box display="flex" justifyContent="space-between" alignItems="center">
                {t('no_option')}
                <Button variant="outlined" color="primary" onMouseDown={onClickAdd}>
                  {t('swal.add_new')}
                </Button>
              </Box>
            ) : (
              t('no_option')
            )
          }
        />
        <FormInput invalid={inputHasErrors} hidden />
        <FormFeedback invalid>{t(inputHasErrors)}</FormFeedback>
      </FormGroup>
    </div>
  );
}
